// extracted by mini-css-extract-plugin
export const team = "y_bT";
export const team_title = "y_bV";
export const team_btn = "y_bW";
export const team_list = "y_bX";
export const team_item = "y_bY";
export const team_name = "y_bZ";
export const team_position = "y_b0";
export const team_pic = "y_b1";